import classNames from 'classnames'
import ServiceIcons from '@components/ServiceIcons'
import Icon from '@components/Icon'
import styles from './styles.module.scss'

const Services = ({ services }) => (
    <div className={classNames('container-fluid', styles.services)}>
        <div className="container">
            <div className="row no-gutters">
                <div className={classNames('col', 'text-center', 'clearfix', styles.header)}>
                    <h2>
                        <T>car.park.services.title</T>
                    </h2>
                </div>
            </div>
            <div className={classNames('row', 'no-gutters', 'text-center', 'justify-content-center', styles.icons)}>
                <ServiceIcons
                    services={services}
                    render={({ type, title, index, color }) => (
                        <div className={styles.col} key={index}>
                            <div className={styles.icon}>
                                <Icon style={{ color }} type={type} size="xxxl" />
                            </div>
                            <span className="clearfix" />
                            <h4 className={classNames('d-inline-block', styles.iconDescription)}>
                                <T>{title}</T>
                            </h4>
                        </div>
                    )}
                />
            </div>
        </div>
    </div>
)

export default Services
